import type { IconData } from '@stacksjs/iconify-core'

export const audio: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m110.763 110.763l-22.7-22.7c-.095.1-.193.186-.288.281a238.483 238.483 0 0 0-.7 336.573l22.7-22.7a206.144 206.144 0 0 1 .988-291.462Zm314.306-22.415c-.4-.4-.817-.793-1.223-1.194l-22.7 22.7a206.14 206.14 0 0 1 1.5 292.8l22.7 22.7a238.49 238.49 0 0 0-.281-337Z\"/><path fill=\"currentColor\" d=\"M153.523 153.522a145.746 145.746 0 0 0-.989 205.944l22.617-22.617a113.8 113.8 0 0 1 .989-160.71Zm182.25 21.705a113.8 113.8 0 0 1 1.5 162.05L359.9 359.9a145.746 145.746 0 0 0-1.5-207.285Zm-41.007 41.007a55.914 55.914 0 1 0 17.658 40.759a55.78 55.78 0 0 0-17.658-40.759m-38.342 64.759a24 24 0 1 1 24-24a24 24 0 0 1-24 24\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default audio
